import React from 'react';
export default () => {
  return (
    <div className="container">
      <h2>404</h2>
      <p>We couldn't find the page you were looking for...</p>
      <a href="/">Go Home</a>
    </div>
  )
}